const answersData = [
  {
    _id: "1",
    userName: "Ayush Chauhan",
    userCred: "Autodiadacted & Sophophilic",
    ques: "How is the placement of galgotias college of engineering and technology(for all branches) I am a 3rd year engineering student in IT specialization at Galgotias College and also the Placement Coordinator for the year 2016–17.",
    ans:
      "What I have witnessed is that in the month of September 3 giant IT companies visit the campus (Infosys, Wipro and Accenture) which choose majority of the students from the lot and many end up getting the offer from all 3 of them. These companies will offer you a CTC of 3–3.5 lakh/annum.    People from all the branches sit for the interview of these tech giant companies. For CSE/IT many companies visit our campus and many pool campus drives also take place in our campus. Like this year, HCL made its pool campus drive. This year 2 of the students were placed in the company named Zycus and were offered a package of 6 LPA. These students are from IT branch Other companies for the CSE and IT branch are Accenture, IBM. This year off-campus offers include from Amazon, flipkart and Reliance(7lakh/annum). Amazon placement boy is from EE branch.",
    views: 500,
    upvotes: 55,
    downvotes: 3,
    comments: 5,
    quality: 0.5
  },
  {
    _id: "2",
    userName: "Ayush Chauhan",
    userCred: "Autodiadacted & Sophophilic",
    ques: "When will the result of first semester be released?",
    ans:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    views: 500,
    upvotes: 55,
    downvotes: 3,
    comments: 6,
    quality: 0.5
  },
  {
    _id: "3",
    userName: "Ayush Chauhan",
    userCred: "Autodiadacted & Sophophilic",
    ques:
      "What are your opinions on Online Exams being conducted by AKTU for the final year studentts?",
    ans:
      "Google itself indicates the most important factors of the page quality. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    views: 500,
    upvotes: 55,
    downvotes: 3,
    comments: 10,
    quality: 0.5
  },
  {
    _id: "4",
    userName: "Ayush Chauhan",
    userCred: "Autodiadacted & Sophophilic",
    ques:
      "Can anyone suggest me a roadmap for Web Development as a Career path?",
    ans:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Google itself indicates the most important factors of the page quality.",
    views: 500,
    upvotes: 55,
    downvotes: 3,
    comments: 2,
    quality: 0.7
  },
  {
    _id: "5",
    userName: "Ayush Chauhan",
    userCred: "Autodiadacted & Sophophilic",
    ques:
      "Which is included in UPSEE counseling- galgotia college or galgotia university? ",
    ans:
      "Its (097)Galgotias College of Engineering and Technology, Knowledge Park-II, Greater Noida which comes under UPTU and takes studenta through UPSEE couselling.Galgotias University takes a different Entrance examination for admission(GEEE).",
    views: 500,
    upvotes: 55,
    downvotes: 3,
    comments: 2,
    quality: 0.7
  },
  {
    _id: "6",
    userName: "Ayush Chauhan",
    userCred: "Autodiadacted & Sophophilic",
    ques:
      "Is there a library in galgotias college?",
    ans:
    "Yes,The library is very big with over 300 seating capacity and over 30000 books and 50+ monthly magazine subscription. Discipline rules are very strict in GCET library.There are also 5–7 Computers inside the library with free internet connection which you can use for educational purposes.",
    views: 500,
    upvotes: 55,
    downvotes: 3,
    comments: 2,
    quality: 0.7
  },
  {
    _id: "7",
    userName: "Ayush Chauhan",
    userCred: "Autodiadacted & Sophophilic",
    ques:
      "Which is better- Galgotia University or Galgotia college?",
    ans: "The owner of both the university and college is same but if You want to do Engeenering then Galgotias College is better option in these two. I have done my engineering from Galgotias College so i know it.It's not a very good college, try for a government college like IET, Lucknow which is also a College of AKTU. And if You are very good in studies then do preparation for the Jee-Mains and try to Get admission in IIT's or NIT's because these are the best college in India for engeenering with good quality education. Let's talk about Galgotias College. If you have money and want to get a college in greater noida then this is not a bad option. GL bajaj is also a good option. GL bajal is good in classes (uniform compulsory) and on the other hand “Maje krne h” Then join galgotias. (no uniform). "
  },
  {
  _id: "8",
  userName: "Ayush Chauhan",
    userCred: "Autodiadacted & Sophophilic",
    ques:"What is the criteria for changing branch in galgotias college of engineering and technology? ",
    ans: "It depends on which branch you are going for and what percentage you have got in the first year. Every branch have its own cutoff percentage. CS/IT leads this with more than 80% cutoff . It also depends on if their is any seat available. It’s quite easy in galgotias if you have good percentage."
  }
];

export default answersData;
